"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_COORDINATES_RESULTS_WITH_RHS_LEVEL = exports.GET_COORDINATES_RESULTS = void 0;
exports.GET_COORDINATES_RESULTS = {
    aggregations: {
        accommodationTypes: [
            { accommodationId: 'ACCOM-3', count: 2 },
            { accommodationId: 'ACCOM-1', count: 17 },
        ],
        features: [
            {
                featureId: 'FILT-11',
                featureName: 'Television',
                featureCode: null,
                count: 19,
            },
            {
                featureId: 'FILT-7',
                featureName: 'Sauna',
                featureCode: null,
                count: 4,
            },
            {
                featureId: 'FILT-22',
                featureName: 'Fishing cottages',
                featureCode: null,
                count: 4,
            },
            {
                featureId: 'FILT-3',
                featureName: 'Dishwasher',
                featureCode: null,
                count: 17,
            },
            {
                featureId: 'FILT-24',
                featureName: 'Golf course',
                featureCode: null,
                count: 3,
            },
            {
                featureId: 'FILT-6',
                featureName: 'Satellite TV',
                featureCode: null,
                count: 19,
            },
            {
                featureId: 'FILT-4',
                featureName: 'Fireplace',
                featureCode: null,
                count: 1,
            },
            {
                featureId: 'FILT-30',
                featureName: 'Panoramic view',
                featureCode: null,
                count: 13,
            },
            {
                featureId: 'FILT-5',
                featureName: 'Internet',
                featureCode: null,
                count: 17,
            },
            {
                featureId: 'FILT-31',
                featureName: 'Pet friendly',
                featureCode: null,
                count: 4,
            },
            {
                featureId: 'FILT-33',
                featureName: 'Short break',
                featureCode: null,
                count: 3,
            },
            {
                featureId: 'FILT-32',
                featureName: 'Pets are not allowed',
                featureCode: null,
                count: 15,
            },
            {
                featureId: 'FILT-20',
                featureName: 'Child friendly',
                featureCode: null,
                count: 2,
            },
            {
                featureId: 'FILT-26',
                featureName: 'Long term rental',
                featureCode: null,
                count: 1,
            },
            {
                featureId: 'FILT-23',
                featureName: 'Flexible arrival',
                featureCode: null,
                count: 6,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            { bathrooms: 1, count: 9 },
            { bathrooms: 2, count: 7 },
            { bathrooms: 3, count: 1 },
            { bathrooms: 4, count: 1 },
            { bathrooms: 6, count: 1 },
        ],
        bedrooms: [
            { bedrooms: 0, count: 1 },
            { bedrooms: 1, count: 4 },
            { bedrooms: 2, count: 8 },
            { bedrooms: 3, count: 2 },
            { bedrooms: 4, count: 1 },
            { bedrooms: 5, count: 2 },
            { bedrooms: 6, count: 1 },
        ],
        regions: { rhs1: [], rhs2: [], rhs3: [], rhs4: [], rhs5: [] },
        grades: [
            { grade: '3', count: 15 },
            { grade: '4', count: 4 },
        ],
    },
    coordinates: [
        { id: 'ATA054', lat: 47.0611, lng: 10.3679 },
        { id: 'ATA053', lat: 47.0611, lng: 10.3679 },
        { id: 'ATI158', lat: 47.075, lng: 10.4038 },
        { id: 'ATI504', lat: 47.06, lng: 10.3661 },
        { id: 'ATI654', lat: 47.0618, lng: 10.3713 },
        { id: 'ATI503', lat: 47.06, lng: 10.3661 },
        { id: 'ATI432', lat: 47.074, lng: 10.4241 },
        { id: 'ATI157', lat: 47.075, lng: 10.4038 },
        { id: 'ATI887', lat: 47.0479, lng: 10.3412 },
        { id: 'ATA052', lat: 47.0611, lng: 10.3679 },
        { id: 'ATI506', lat: 47.0615, lng: 10.3699 },
        { id: 'ATI458', lat: 47.0646, lng: 10.3883 },
        { id: 'ATI434', lat: 47.074, lng: 10.4241 },
        { id: 'ATA051', lat: 47.0611, lng: 10.3679 },
        { id: 'ATI653', lat: 47.0646, lng: 10.377 },
        { id: 'ATI763', lat: 47.0479, lng: 10.3412 },
        { id: 'ATA310', lat: 47.0513, lng: 10.3505 },
        { id: 'ATA311', lat: 47.0513, lng: 10.3505 },
        { id: 'ATA312', lat: 47.0513, lng: 10.3505 },
    ],
    total: 19,
};
exports.GET_COORDINATES_RESULTS_WITH_RHS_LEVEL = {
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '9999',
                featureName: 'Shiny Feature',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9857',
                featureName: 'Pets Allowed',
                featureCode: null,
                count: 1,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 3,
                count: 1,
            },
        ],
        bedrooms: [
            {
                bedrooms: 2,
                count: 1,
            },
        ],
        regions: {
            rhs1: [
                {
                    count: 1,
                    region: 'England',
                    id: 21667,
                },
            ],
            rhs2: [
                {
                    count: 1,
                    region: 'North West England',
                    id: 21952,
                },
            ],
            rhs3: [
                {
                    count: 1,
                    region: 'Cheshire',
                    id: 21953,
                },
            ],
            rhs4: [
                {
                    count: 1,
                    region: 'Cheshire',
                    id: 21954,
                },
            ],
            rhs5: [
                {
                    count: 1,
                    region: 'Chester',
                    id: 21955,
                },
            ],
        },
        grades: [
            {
                grade: '4',
                count: 1,
            },
        ],
        reviews: [
            {
                score: 0,
                count: 0,
            },
            {
                score: 1,
                count: 0,
            },
            {
                score: 2,
                count: 0,
            },
            {
                score: 3,
                count: 1,
            },
            {
                score: 4,
                count: 0,
            },
            {
                score: 5,
                count: 0,
            },
        ],
    },
    total: 1,
    coordinates: [
        {
            id: 'FCK',
            lat: -4.390309,
            lng: 50.73595,
        },
    ],
    rhsLevel: 'rhs1',
};
//# sourceMappingURL=getCoordinatesResults.js.map